export default Object.freeze({
    SCHEDULE_PAYCODE_EDITS: 0,
    TIME_OFF_REQUESTS: 1,
});
